// extracted by mini-css-extract-plugin
export var details = "_ez-0";
export var inspectorPopover = "_ez-1";